"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.downexStimulus = void 0;
const plugin_html_multi_response_1 = __importDefault(require("@jspsych-contrib/plugin-html-multi-response"));
const taskStore_1 = require("../../../taskStore");
const __1 = require("../../..");
const helpers_1 = require("../../shared/helpers");
const taskSetup_1 = require("../../taskSetup");
const replayButtonHtmlId = 'replay-btn-revisited';
let practiceResponses = [];
let startTime;
let cycleId = 0; // disable audio if the trial has changed since the loop started - prevent overlapping audio
const downexStimulus = (layoutConfigMap, animate, trial) => {
    return {
        type: plugin_html_multi_response_1.default,
        data: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            let isPracticeTrial = stim.assessmentStage === 'practice_response';
            return {
                // not camelCase because firekit
                save_trial: true,
                assessment_stage: stim.assessmentStage,
                // not for firekit
                isPracticeTrial: isPracticeTrial,
            };
        },
        stimulus: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            const t = (0, taskStore_1.taskStore)().translations;
            const imageSrc = __1.mediaAssets.images[(0, helpers_1.camelize)(stim.item)];
            let itemText;
            const audioFile = stim.audioFile;
            if (typeof audioFile !== 'string') {
                itemText = audioFile.map((file) => t[(0, helpers_1.camelize)(file)]).join(' ');
            }
            else {
                itemText = t[(0, helpers_1.camelize)(audioFile)];
            }
            return `<div class="lev-stimulus-container">
                        ${(0, helpers_1.getParticipantUtilityButtonsHtml)(replayButtonHtmlId)}
                        <div class="lev-row-container instruction-small">
                            <p>${itemText}</p>
                        </div>
                        <div class="lev-stim-content-x-2">
                        <img
                            src=${imageSrc}
                            alt="Image not loading: ${imageSrc}. Please continue the task."
                        />
                        </div>
                    </div>`;
        },
        prompt_above_buttons: true,
        button_choices: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            const itemLayoutConfig = layoutConfigMap === null || layoutConfigMap === void 0 ? void 0 : layoutConfigMap[stim.itemId];
            const choices = itemLayoutConfig.response.displayValues;
            return choices.map((choice) => {
                const imageUrl = __1.mediaAssets.images[(0, helpers_1.camelize)(choice)];
                return `<img src=${imageUrl} alt=${choice} />`;
            });
        },
        keyboard_choices: () => 'NO_KEYS',
        button_html: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            const itemLayoutConfig = layoutConfigMap === null || layoutConfigMap === void 0 ? void 0 : layoutConfigMap[stim.itemId];
            const classList = [...itemLayoutConfig.classOverrides.buttonClassList];
            if (stim.assessmentStage === 'practice_response') {
                classList.push('practice-btn');
            }
            return `<button class="${classList.join(' ')}" ${stim.assessmentStage === 'practice_response' ? 'disabled' : ''}>
                      %choice%
                    </button>`;
        },
        on_load: async () => {
            startTime = performance.now();
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            // set up replay audio with animations
            const trialAudio = stim.audioFile;
            (0, helpers_1.addExperimenterButtons)();
            (0, helpers_1.setupFullscreenButton)();
            const replayButton = document.getElementById('replay-btn-revisited');
            if (animate) {
                if (replayButton) {
                    replayButton.addEventListener('click', () => {
                        animateAndPlayAudio();
                    });
                }
            }
            else {
                const pageStateHandler = new helpers_1.PageStateHandler(trialAudio, true);
                (0, helpers_1.setupReplayAudio)(pageStateHandler);
            }
            const stimContainer = document.querySelector('.lev-stim-content-x-2');
            const stimImage = stimContainer === null || stimContainer === void 0 ? void 0 : stimContainer.querySelector('img');
            const buttonContainer = document.getElementById('jspsych-html-multi-response-btngroup');
            const buttons = Array.from((buttonContainer === null || buttonContainer === void 0 ? void 0 : buttonContainer.querySelectorAll('button')) || []);
            const itemLayoutConfig = layoutConfigMap === null || layoutConfigMap === void 0 ? void 0 : layoutConfigMap[stim.itemId];
            // set up practice button listeners
            const incorrectPracticeResponses = [];
            (0, taskStore_1.taskStore)('incorrectPracticeResponses', incorrectPracticeResponses);
            function onCorrect() {
                helpers_1.PageAudioHandler.stopAndDisconnectNode();
                cycleId++;
                helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio.feedbackRightOne);
            }
            function onIncorrect() {
                helpers_1.PageAudioHandler.stopAndDisconnectNode();
                cycleId++;
                const rspImages = buttons.map((button) => button.querySelector('img'));
                const targetImageIdx = rspImages.findIndex((image) => (image === null || image === void 0 ? void 0 : image.alt) === stim.answer);
                if (targetImageIdx !== -1) {
                    const targetButton = buttons[targetImageIdx];
                    targetButton.style.animation = 'none';
                    targetButton.offsetHeight; // Force reflow
                    targetButton.style.animation = 'pulse 2s 0s 2';
                }
                const audioConfig = {
                    restrictRepetition: {
                        enabled: true,
                        maxRepetitions: 2,
                    },
                };
                helpers_1.PageAudioHandler.playAudio(__1.mediaAssets.audio.matrixReasoningFeedbackIncorrectDownex, audioConfig);
            }
            (0, helpers_1.addPracticeButtonListeners)(stim.answer.toString(), taskSetup_1.isTouchScreen, itemLayoutConfig.response.values, onCorrect, onIncorrect);
            async function animateAndPlayAudio() {
                cycleId++;
                const thisCycleId = cycleId;
                // replay button should be disabled while animations are happening
                if (replayButton) {
                    replayButton.disabled = true;
                }
                // set up animation
                let itemsToAnimate = [buttons, stimImage];
                const audioConfig = {
                    restrictRepetition: {
                        enabled: false,
                        maxRepetitions: 2,
                    },
                };
                if (typeof trialAudio === 'string') {
                    const audioUri = __1.mediaAssets.audio[(0, helpers_1.camelize)(trialAudio)] || __1.mediaAssets.audio.nullAudio;
                    helpers_1.PageAudioHandler.playAudio(audioUri);
                }
                else {
                    for (const [index, audioFile] of trialAudio.entries()) {
                        const audioUri = __1.mediaAssets.audio[(0, helpers_1.camelize)(audioFile)] || __1.mediaAssets.audio.nullAudio;
                        // make sure the trial has not changed since the loop started
                        if (thisCycleId !== cycleId || (0, taskStore_1.taskStore)().isPaused) {
                            break;
                        }
                        await new Promise((resolve) => {
                            const configWithCallback = {
                                ...audioConfig,
                                onEnded: () => {
                                    setTimeout(() => resolve(), 1000);
                                },
                            };
                            if (animate && (0, helpers_1.camelize)(audioFile) !== 'sdsYourTurn') {
                                itemsToAnimate = (0, helpers_1.popAnimation)(itemsToAnimate, 'pulse 2s 0s');
                            }
                            helpers_1.PageAudioHandler.playAudio(audioUri, configWithCallback);
                        });
                    }
                }
                if (replayButton) {
                    replayButton.disabled = false;
                }
                (0, helpers_1.enableAllButtons)();
            }
            animateAndPlayAudio();
        },
        on_finish: (data) => {
            helpers_1.PageAudioHandler.stopAndDisconnectNode();
            cycleId++;
            const stimulus = trial || (0, taskStore_1.taskStore)().nextStimulus;
            const itemLayoutConfig = layoutConfigMap === null || layoutConfigMap === void 0 ? void 0 : layoutConfigMap[stimulus.itemId];
            const { corpus } = (0, taskStore_1.taskStore)();
            let responseValue = null;
            let target = null;
            let responseIndex = null;
            if (itemLayoutConfig) {
                const { response } = itemLayoutConfig;
                if (!response) {
                    throw new Error('Choices not defined in the config');
                }
                responseIndex = data.button_response;
                responseValue = response.values[responseIndex];
                target = response.target;
                data.correct = responseValue === target;
            }
            // update running score and answer lists
            if (data.correct) {
                if (stimulus.assessmentStage !== 'practice_response') {
                    // practice trials don't count toward total
                    taskStore_1.taskStore.transact('totalCorrect', (oldVal) => oldVal + 1);
                    (0, taskStore_1.taskStore)('numIncorrect', 0); // reset incorrect trial count
                }
                practiceResponses = [];
            }
            else {
                // Only increase incorrect trials if response is incorrect not a practice trial
                if (stimulus.assessmentStage !== 'practice_response') {
                    taskStore_1.taskStore.transact('numIncorrect', (oldVal) => oldVal + 1);
                }
            }
            // save data
            taskSetup_1.jsPsych.data.addDataToLastTrial({
                // specific to this trial
                item: stimulus.item,
                answer: target,
                distractors: stimulus.distractors,
                corpusTrialType: stimulus.trialType,
                responseType: 'mouse',
                responseLocation: responseIndex,
                itemUid: stimulus.itemUid,
                audioFile: stimulus.audioFile,
                corpus: corpus,
                audioButtonPresses: helpers_1.PageAudioHandler.replayPresses,
            });
            // corpusId and itemId fields are used by ROAR but not ROAD
            if ((0, taskStore_1.taskStore)().storeItemId) {
                taskSetup_1.jsPsych.data.addDataToLastTrial({
                    itemId: stimulus.itemId,
                });
            }
            // Adding this seperately or otherwise it will overide
            // the response value added from practice trials
            if (stimulus.assessmentStage !== 'practice_response') {
                taskSetup_1.jsPsych.data.addDataToLastTrial({
                    response: responseValue,
                });
            }
            if (stimulus.assessmentStage === 'practice_response') {
                const endTime = performance.now();
                const calculatedRt = Math.round(endTime - startTime);
                taskSetup_1.jsPsych.data.addDataToLastTrial({
                    rt: calculatedRt,
                });
            }
            if (stimulus.assessmentStage === 'test_response') {
                taskStore_1.taskStore.transact('testTrialCount', (oldVal) => oldVal + 1);
            }
        },
        response_ends_trial: () => {
            const stim = trial || (0, taskStore_1.taskStore)().nextStimulus;
            return stim.assessmentStage !== 'practice_response';
        },
    };
};
exports.downexStimulus = downexStimulus;
